import { ActionTypes } from '../constants/actionTypes';

const initialState = {
   selectedDate : {
    from_date: null,
    to_date: null
   }
}

export const dateRangeReducer = (state= initialState, {type, payload}) => {
  switch(type) {
    case ActionTypes.SET_SELECTED_DATERANGE:
        return{...state,
            selectedDate: {
                from_date: payload.startDate,
                to_date: payload.endDate
            }
        };
    default:
    return state;
  }
}